import { Suspense, useEffect, useRef, useState } from "react";
import SwalAlert from "../../../../../services/swalService/SwalService";
import { useCheckGMAPCertificationByEmailMutation, useLazyGetEmployeeDetailsByEmployeeIdQuery, useUpdateEmployeesByCorporateEmployeeIdMutation } from "../../../../../app/services/Employees/employeeApi";
import { EditEmployeeFormData } from "../data/NewEmployeeData";
import CenterModel from "../../../../../components/ui/centerModel/CenterModel";
import DataLoader from "../../../../../components/ui/dataLoader/DataLoader";
import FormCreator from "../../../../../components/Forms/FormCreator";
import Buttons from "../../../../../components/ui/button/Buttons";
import ToastService from "../../../../../services/toastService/ToastService";

const EditEmployee = ({ show, id, closeModal, employee }) => {
    const editEmployeeRef = useRef();
    const { error, success } = SwalAlert();
    const [formdata, setFormdata] = useState(EditEmployeeFormData);
    const phoneFieldMap = { contactNumberId: "contactNumber", };
    const [updateEmployee, { isSuccess: updateEmployeeIsSuccess, isLoading: updateEmployeeIsLoading, data: updateEmployeeData, },] = useUpdateEmployeesByCorporateEmployeeIdMutation();
    const [checkGMAPCertificationByEmail, { isSuccess: checkCertificationIsSuccess, isLoading: checkCertificationIsLoading, data: checkCertificationData, },] = useCheckGMAPCertificationByEmailMutation();
    const [getEmployeeDetailsById, { isSuccess: employeeDetailsIsSuccess, isLoading: employeeDetailsIsLoading, data: employeeDetailsData, },] = useLazyGetEmployeeDetailsByEmployeeIdQuery();

    const handleModalClose = () => {
        closeModal();
        handleClear();
    }

    const handleClear = () => {
        closeModal();
        const updatedForm = { ...EditEmployeeFormData };
        setFormdata(updatedForm);
    };

    const handleFormFieldChange = (dataField, value) => {
        let form = { ...formdata };
        form.initialState = { ...form.initialState };
        if (["contactNumber"].includes(dataField)) {
            const updatedInitialState = { ...form.initialState, [dataField]: value.replace(/\D/g, "") }
            setFormdata((prev) => ({ ...prev, ...form, initialState: { ...prev.initialState, ...updatedInitialState, }, }));
        }
        else if (Object.keys(phoneFieldMap).includes(dataField)) {
            const relatedInput = phoneFieldMap[dataField];
            //let updatedMaxLength = value?.value == 153 ? 8 : 25;
            const updatedFormFields = form.formFields.map((field) => {
                if (field.id === relatedInput) {
                    return { ...field, fieldSetting: { ...field.fieldSetting, }, };
                }
                return field;
            });
            // const updatedInitialState = { ...form.initialState, [dataField]: value?.value || "", [relatedInput]: "", };
            const updatedInitialState = { ...form.initialState, [dataField]: value?.value || "",  };
            setFormdata((prev) => ({ ...prev, formFields: updatedFormFields, initialState: { ...prev.initialState, ...updatedInitialState, }, }));
        }
        else {
            // update field value safely
            setFormdata((prev) => ({ ...prev, ...form, initialState: { ...prev.initialState, ...form.initialState, [dataField]: value, }, }));
        }
    }

    const handleBlurField = (dataField, value) => {
        if (dataField == "email") {
            let req = { emailAddress: value }
            checkGMAPCertificationByEmail(req);
        }
    }

    const handleUpdateEmployee = () => {
        const formDetails = editEmployeeRef?.current?.getFormData();
        if (!formDetails) {
            error("Please fill in all mandatory fields to continue.", "");
            return
        }
        let req = {
            SGBCCorporateRepresentativeId: employee?.sgbcCorporateRepresentativeId,
            // sGBCCorporateMemberId: id,
            salutationId: formDetails?.salutationId?.value || formDetails?.salutationId,
            firstName: formDetails?.firstName,
            lastName: formDetails?.lastName,
            email: formDetails?.email,
            gMPCertification: formDetails?.gmpCertification || "",
            contactnumberCountryId: formDetails?.contactNumberId?.value || formDetails?.contactNumberId,
            contactNumber: formDetails?.contactNumber,
            designation: formDetails?.designation,
            jobLevelId: formDetails?.jobLevelId?.value || formDetails?.jobLevelId,
            jobFunctionId: formDetails?.jobFunctionId?.value || formDetails?.jobFunctionId,
            isUpcomingEvents: formDetails?.isUpcomingEvent,
            isMonthlyBulletin: formDetails?.isMonthlyBulletin,
            isBeSectorUpdates: formDetails?.isSectorUpdate,
        }
        updateEmployee(req)
    }

    useEffect(() => {
        getEmployeeDetailsById(employee?.sgbcCorporateRepresentativeId);
    }, [employee]);

    useEffect(() => {
        if (!employeeDetailsIsLoading && employeeDetailsIsSuccess && employeeDetailsData) {
            let updatedState = {
                salutationId: employeeDetailsData?.salutationId || null,
                firstName: employeeDetailsData?.firstName || null,
                lastName: employeeDetailsData?.lastName || null,
                email: employeeDetailsData?.email || null,
                designation: employeeDetailsData?.designation || null,
                jobLevelId: employeeDetailsData?.jobLevelId || null,
                jobFunctionId: employeeDetailsData?.jobFunctionId || null,
                gmpCertification: employeeDetailsData?.gmpCertification || null,
                contactNumber: employeeDetailsData?.contactNumber || null,
                contactNumberId: employeeDetailsData?.contactnumberCountryId || null,
                isUpcomingEvent: employeeDetailsData?.isUpcomingEvents || false,
                isMonthlyBulletin: employeeDetailsData?.isMonthlyBulletin || false,
                isSectorUpdate: employeeDetailsData?.isBeSectorUpdates || false,
            }
            setFormdata(prev => ({
                ...prev,
                initialState: { ...updatedState },
                formFields: prev.formFields.map(field => {
                    if (field.id === "emailSearch") {
                        return {
                            ...field,
                            fieldSetting: {
                                ...field.fieldSetting, formTitle: `GMP Certification : ${(employeeDetailsData?.gmpCertification != "" && employeeDetailsData?.gmpCertification != null) ? employeeDetailsData?.gmpCertification : "-"} `,
                            }
                        }
                    }
                    return field;
                }),
            }));
        }
    }, [employeeDetailsIsLoading, employeeDetailsIsSuccess, employeeDetailsData])

    useEffect(() => {
        if (!checkCertificationIsLoading && checkCertificationIsSuccess && checkCertificationData) {
            const email = editEmployeeRef?.current?.getFieldValue("email");
            let upadteIntialState = { email: email || null, gmpCertification: checkCertificationData?.applicationType || "" }
            if (checkCertificationData?.applicationType != "") {
                ToastService.success("GMAP Certificate found successfully.", "Successful");
            }
            setFormdata(prev => ({
                ...prev,
                initialState: { ...prev.initialState, ...upadteIntialState },
                formFields: prev.formFields.map(field => {
                    if (field.id === "emailSearch") {
                        return {
                            ...field,
                            fieldSetting: {
                                ...field.fieldSetting, formTitle: `GMP Certification : ${checkCertificationData?.applicationType != "" ? checkCertificationData?.applicationType : "-"} `,
                            }
                        }
                    }
                    return field;
                }),
            }));
        }
    }, [checkCertificationIsLoading, checkCertificationIsSuccess, checkCertificationData,]);

    useEffect(() => {
        if (!updateEmployeeIsLoading && updateEmployeeIsSuccess && updateEmployeeData) {
            success("Employee has been update successfully.", "Successful");
            handleClear();
        }
    }, [updateEmployeeIsLoading, updateEmployeeIsSuccess, updateEmployeeData,]);

    const formActionHandler = {
        CLEAR: handleClear,
    };

    return (
        <div>
            <CenterModel
                modelTitle={"Edit Employee"}
                show={show}
                className="new-employee-model"
                handleClose={() => handleModalClose()}
            >
                <div className="row">
                    <Suspense fallback={<DataLoader />}>
                        <FormCreator
                            ref={editEmployeeRef}
                            {...formdata}
                            onActionChange={formActionHandler}
                            onFormFieldValueChange={handleFormFieldChange}
                            onFormFieldBlur={handleBlurField}
                        />
                    </Suspense>
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <Buttons
                        className="center-btn mt-4"
                        buttonText="Submit"
                        buttonTypeClassName="success-btn"
                        isLoading={updateEmployeeIsLoading}
                        isDisable={updateEmployeeIsLoading}
                        onClick={() => handleUpdateEmployee()}
                    />
                </div>
            </CenterModel>
        </div>
    )
}

export default EditEmployee
